import GlobalStyles from '@mui/material/GlobalStyles'

// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
const styles = {
  'body, #root': { minHeight: '100vh' },
  body: { margin: 0, padding: 0, borderBox: 'box-sizing', overflowY: 'scroll' },
}
// can be constant, as we don't want to rerender on any changes
// Could also be achieved with `useMemo` for `styles`.
// see https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override
const globalStyles = <GlobalStyles styles={styles} />

export const GlobalStylesOverride = () => {
  return globalStyles
}
